import { Package, Truck, CalendarCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";

const ActiveBookingsSection = ({ bookings }) => {
  if (!bookings || bookings.length === 0) {
    return null;
  }

  return (
    <div className="mt-3 p-3 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border border-green-200">
      <div className="flex items-center gap-2 mb-2">
        <CalendarCheck className="w-4 h-4 text-green-600" />
        <span className="font-medium text-green-800 text-sm">
          {bookings.length} réservation(s) en cours
        </span>
      </div>
      <div className="space-y-2">
        {bookings.map((booking) => (
          <BookingItem key={booking.id} booking={booking} />
        ))}
      </div>
    </div>
  );
};

const BookingItem = ({ booking }) => {
  const getTypeLabel = () => {
    if (booking.booking_type === "pickup") return "Ramassage seul";
    if (booking.booking_type === "delivery") return "Livraison seule";
    return "Ramassage + Livraison";
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' });
  };

  return (
    <div className="flex items-center gap-2 text-xs bg-white p-2 rounded border border-green-100 flex-wrap">
      <Badge 
        className={booking.status === "confirmed" 
          ? "bg-green-500 text-white text-xs" 
          : "bg-amber-500 text-white text-xs"}
      >
        {booking.status === "confirmed" ? "Confirmée" : "En attente"}
      </Badge>
      <span className="text-slate-600">{getTypeLabel()}</span>
      {booking.pickup_slot && (
        <span className="flex items-center gap-1 text-pink-600">
          <Package className="w-3 h-3" />
          {formatDate(booking.pickup_slot.date)} {booking.pickup_slot.start_time}
        </span>
      )}
      {booking.delivery_slot && (
        <span className="flex items-center gap-1 text-blue-600">
          <Truck className="w-3 h-3" />
          {formatDate(booking.delivery_slot.date)} {booking.delivery_slot.start_time}
        </span>
      )}
    </div>
  );
};

export default ActiveBookingsSection;
